import React from 'react';

let bodyObserver = null;

/**
 * react-datetime renderDay: expose selected / today / disabled state for assistive tech.
 * Uses role="gridcell" with aria-selected; pair with ensureReactDatetimeA11yEnhancements() so the
 * parent table has role="grid".
 */
export function renderAccessibleDatetimeDay(props, currentDate) {
  const { key, ...rest } = props;
  const className = rest.className || '';
  const isSelected = /\brdtActive\b/.test(className);
  const isToday = /\brdtToday\b/.test(className);
  const isDisabled = /\brdtDisabled\b/.test(className);

  return (
    <td
      key={key}
      {...rest}
      aria-current={isToday ? 'date' : undefined}
      aria-disabled={isDisabled ? true : undefined}
      aria-selected={isSelected ? 'true' : 'false'}
      role="gridcell"
    >
      {currentDate.date()}
    </td>
  );
}

function enhanceNavButtons(picker) {
  const prevButton = picker.querySelector('.rdtPrev');
  const nextButton = picker.querySelector('.rdtNext');

  if (prevButton && !prevButton.getAttribute('role')) {
    prevButton.setAttribute('role', 'button');
    prevButton.setAttribute('aria-label', 'Previous month');
    prevButton.setAttribute('tabindex', '0');
  }

  if (nextButton && !nextButton.getAttribute('role')) {
    nextButton.setAttribute('role', 'button');
    nextButton.setAttribute('aria-label', 'Next month');
    nextButton.setAttribute('tabindex', '0');
  }
}

function syncCalendarGridRoles(picker) {
  const table = picker.querySelector('.rdtDays table');
  if (!table || table.getAttribute('data-bf-rdt-grid-synced') === 'true') {
    return;
  }

  table.setAttribute('data-bf-rdt-grid-synced', 'true');
  table.setAttribute('role', 'grid');
  table.querySelectorAll('tr').forEach((tr) => {
    tr.setAttribute('role', 'row');
  });
  table.querySelectorAll('thead th').forEach((th) => {
    th.setAttribute('role', 'columnheader');
  });
}

function enhanceAllReactDatetimePickers() {
  document.querySelectorAll('.rdtPicker').forEach((picker) => {
    enhanceNavButtons(picker);
    syncCalendarGridRoles(picker);
  });
}

/**
 * Idempotent: wires MutationObserver once so every react-datetime calendar (any route) gets
 * grid roles on the table and nav button labels.
 */
export function ensureReactDatetimeA11yEnhancements() {
  if (typeof document === 'undefined' || bodyObserver) {
    return;
  }

  enhanceAllReactDatetimePickers();

  bodyObserver = new MutationObserver(() => {
    enhanceAllReactDatetimePickers();
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
